<template>
  <material-card
    class="mx-4"
    color="primary">
    <v-data-table
      :rows-per-page-text="$t('rows-per-page-text')"
      :rows-per-page-items="globalrowsPerPageItems"
      :no-data-text="$t('no-data-available')"
      :headers="headers"
      :items="desserts">
      <template
        slot="headerCell"
        slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-primary"
          v-text="header.text"/>
      </template>
      <template v-slot:items="props">
        <td>{{ props.item.user }}</td>
        <td class="text-xs-left">{{ props.item.document }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.rol }}</td>
      </template>
    </v-data-table>
  </material-card>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: 'Usuario',
          align: 'left',
          sortable: false,
          value: 'user'
        },
        { text: 'Documento', value: 'document', sortable: false },
        { text: 'Nombre', value: 'name', sortable: false },
        { text: 'Apellido', value: 'lastName', sortable: false },
        { text: 'Correo', value: 'email', sortable: false },
        { text: 'rol', value: 'rol', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      desserts: [
        {
          user: 'dprado',
          document: 56782,
          name: 'David',
          lastName: 'Prado',
          email: 'Dprado@gmail.com',
          rol: 'Admin'
        }
      ]
    }
  }
}
</script>
